import React from 'react';
import * as PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Menu } from 'antd';
import { withRouter } from 'react-router-dom';
import RoutedMenuItem from './RoutedMenuItem';
import KeyMenuItem from './KeyMenuItem';
import NewTabMenuItem from './NewTabMenuItem';
import { userHasRoleName } from "../../sections/secured/configure/company/user-util";

const { SubMenu } = Menu;

function ViaDropMenu({
   intl, location, mode, menuStructure, subMenuTitle, click, subMenuClass, sessionUser,
}) {
  const getMenuItem = (item) => {
    if (!showMenuItem(sessionUser, item.allowedRoleNames)) {
       return null;
    }
    if (item.path.startsWith('func:')) {
      return (KeyMenuItem(item.path.substring(5), intl.formatMessage({ id: item.titleId }), click));
    }
    if (item.path.startsWith('link:')) {
      return (NewTabMenuItem(item.path.substring(5), intl.formatMessage({ id: item.titleId }), item.hidden ? item.hidden : false));
    }
    return (RoutedMenuItem(item.path, intl.formatMessage({ id: item.titleId }), null, item.hidden ? item.hidden : false));
  };
  const getGroupItem = (group, index) => {
    if (menuStructure && menuStructure.groups.length === 1) {
      return (
        group.items.map((item, idx) => (getMenuItem(item, idx)))
      );
    }
    const mappedItems = group.items.map((item, idx) => (getMenuItem(item, idx)));
    let hasMenuItem = false;
    const showItems = [];
    mappedItems.forEach(item => {
      if (item != null) {
        hasMenuItem = true;
        showItems.push(item);
      }
    });
    return hasMenuItem ? (
      <Menu.ItemGroup key={index} title={intl.formatMessage({ id: group.titleId })}>
        {showItems}
      </Menu.ItemGroup>
    ) : '';
  };

  const showMenuItem = (sessionUser, allowedRoleNames) => {
    if (sessionUser == null) {
      return true;
    }
    else if (allowedRoleNames == null || allowedRoleNames.length < 1) {
      return true;
    }
    else {
      let show = false;
      allowedRoleNames.forEach(name => show = userHasRoleName(sessionUser, name) ? true : show);
      return show;
    }
  };

  const pathTestsForHighlight = [];
  const splitPath = location.pathname.split('/');
  pathTestsForHighlight.push(`/${splitPath[1]}`);
  if (splitPath.length > 2) { pathTestsForHighlight.push(`/${splitPath[1]}/${splitPath[2]}`); }
  if (splitPath.length > 3) { pathTestsForHighlight.push(`/${splitPath[1]}/${splitPath[2]}/${splitPath[3]}`); }

  return (
    <Menu
      mode={mode}
      selectedKeys={pathTestsForHighlight}
      forceSubMenuRender
    >
      <SubMenu
        className={subMenuClass}
        title={subMenuTitle}
      >
        {
          menuStructure
            ? menuStructure.groups.map((group, idx) => (getGroupItem(group, idx)))
            : <></>
        }
      </SubMenu>
    </Menu>
  );
}

// Validate the prop type parameters.
ViaDropMenu.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string.isRequired }).isRequired,
  mode: PropTypes.string.isRequired,
  menuStructure: PropTypes.shape({ groups: PropTypes.array.isRequired }),
  subMenuTitle: PropTypes.element.isRequired,
  click: PropTypes.func,
  subMenuClass: PropTypes.string,
};

ViaDropMenu.defaultProps = {
  click: () => {},
  subMenuClass: '',
  menuStructure: null,
};

export default withRouter(injectIntl(ViaDropMenu));
